import { useApiClient } from '@marageti/z4-lib';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { useState, useEffect } from 'react';

const ITEMS_PER_PAGE = 1; // Minimal items to fetch only totalHits

const useTotalReviews = ({
  searchItemId,
  searchItemFieldName,
}: {
  searchItemId: string;
  searchItemFieldName: 'partnerId' | 'travelerId' | 'tripMatchId';
}) => {
  const [totalReviews, setTotalReviews] = useState<number>(0);
  const [loadingTotal, setLoadingTotal] = useState<boolean>(false);
  const [errorTotal, setErrorTotal] = useState<ApiError | undefined>(undefined);
  const apiClient = useApiClient();

  useEffect(() => {
    if (!searchItemId) {
      setTotalReviews(0);
      return;
    }

    const fetchTotalReviews = async () => {
      setLoadingTotal(true);
      try {
        const searchResult = await apiClient.reviewsClient.postReviewsSearch({
          filterBy: [
            {
              field: searchItemFieldName,
              value: [searchItemId],
            },
          ],
          sortBy: [
            {
              field: 'createdAt',
              order: 'desc',
            },
          ],
          pagination: {
            limit: ITEMS_PER_PAGE,
            page: 1,
          },
        });
        setTotalReviews(searchResult.totalHits ?? 0);
      } catch (e) {
        setErrorTotal(e as ApiError);
      } finally {
        setLoadingTotal(false);
      }
    };

    fetchTotalReviews();
  }, [searchItemId, searchItemFieldName, apiClient]);

  return { totalReviews, loadingTotal, errorTotal };
};

export default useTotalReviews;
